export const IMPERSONATION_SETTING_ONLY = 'settings_only';
export const IMPERSONATION_FULL_ACCESS = 'full_access';
